type TEnvironment = 'production' | 'development' | 'staging';

export function getEnvironment(): TEnvironment | null {
  if (typeof window === 'undefined') return null;
  if (window.location.host?.includes('stage.iwoca-dev.')) return 'staging';
  if (window.location.host?.includes('iwoca.')) return 'production';
  return 'development';
}
